import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
@Component({
  selector: 'app-common-featured-property',
  templateUrl: './common-featured-property.component.html',
  styleUrls: ['./common-featured-property.component.css']
})
export class CommonFeaturedPropertyComponent implements OnInit {
  @Input() propertyData: any;
  @Input() pClass;
  propertyImage: any;
  address:any = [];


  constructor(public shared: SharedService) {
  }

  ngOnInit(): void {
    // console.log("propertyData", this.propertyData)
    if(this.propertyData.address) {
      this.address.push(this.propertyData.address);
    }
    if(this.propertyData.PropertyToMasterLandmarkData && this.propertyData.PropertyToMasterLandmarkData['landmark_name']) {
      this.address.push(this.propertyData.PropertyToMasterLandmarkData['landmark_name']);
    }
    if(this.propertyData.PropertyToMasterCityData && this.propertyData.PropertyToMasterCityData['city_name']) {
      this.address.push(this.propertyData.PropertyToMasterCityData['city_name']);
    }
    if (this.propertyData && this.propertyData.PropertyToPropertyMediaData && this.propertyData.PropertyToPropertyMediaData.length > 0) {
      for (let i of this.propertyData.PropertyToPropertyMediaData) {
        if (i.category_type && i.images) {
          let _img = i.images.split(",")
          this.propertyImage = _img[0]
        }
      }
    }
  }

  redirectProperty() {
    window.location.href = "/properties-single";
  }
}
